import { useReducedMotion } from 'framer-motion';
import { motion } from "framer-motion";
import { invoicesVariants } from '../../../../utilities/framerVariants';
import {AppContext} from "../../../../context/AppContext";
import styles from './ErrorMessage.module.scss'
import {useContext} from "react";

const ErrorMessage = () => {
    const { windowWidth } = useContext(AppContext);
    const isDesktop = windowWidth >= 768;
    const shouldReduceMotion = useReducedMotion();
    const variant = (element) => {
        return shouldReduceMotion
            ? invoicesVariants.reduced
            : invoicesVariants[element];
    };

    return (
        <motion.div
            className={styles.container}
            variants={variant('errorMessage')}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            <div className={styles.image} />
            <h2 className={styles.header}>There is nothing here</h2>
            <p className={styles.text}>
                Create an invoice by clicking the{' '}
                <span className={styles.bold}>New {isDesktop && 'Invoice'}</span> button and get started
            </p>
        </motion.div>
    );
};

export default ErrorMessage;
